module.exports = __webpack_public_path__ + "static/img/space3.45e938c0.png";